import { isEmpty } from 'lodash'
import { SpecialInstruction, SpecialInstructionsEnum } from '../Types'

export const assembleSpecialInstructions = (
  specialInstructions?: SpecialInstruction[] | undefined
): { specialInstructions: SpecialInstructionsEnum[] } | undefined => {
  const specialInstructionValues = specialInstructions
    ?.filter(({ value }: SpecialInstruction) => value)
    .map(({ value }: SpecialInstruction) => value)

  // @ts-ignore
  return isEmpty(specialInstructionValues) ? undefined : { specialInstructions: specialInstructionValues }
}
